import { getCurrentInstance, onBeforeUnmount, onMounted } from "vue";

export default function useFilterHistory() {
    const { emit } = getCurrentInstance();

    // never use in another composable
    onMounted(() => window.addEventListener("popstate", handlePopState));
    onBeforeUnmount(() =>
        window.removeEventListener("popstate", handlePopState)
    );

    function setFilter(filter) {
        emit("update:modelValue", filter);
        window.history.pushState({ filter: filter }, filter, "");
    }

    function handlePopState(event) {
        const filter = event.state?.filter;
        if (filter) {
            emit("update:modelValue", filter);
        }
    }

    return {
        setFilter,
    };
}
